/* eslint-disable camelcase */
const validate = values => {
    const errors = {};
    if (!values.roleStatus) {
        errors.roleStatus = 'Please select status';
    }
    if (!values.remarks) {
        errors.remarks = 'Please enter your comment';
    }
    if (values.remarks && values.remarks.length > 300) {
        errors.remarks = 'Cannot be more than 300 characters';
    }
    let selectedPermissions = [];
    if (values.access_management) {
        selectedPermissions = [
            ...selectedPermissions,
            ...values.access_management,
        ];
    }
    if (values.refunds) {
        selectedPermissions = [...selectedPermissions, ...values.refunds];
    }
    if (values.reports) {
        selectedPermissions = [...selectedPermissions, ...values.reports];
    }
    if (values.manage_bin) {
        selectedPermissions = [...selectedPermissions, ...values.manage_bin];
    }
    if (values.manage_account) {
        selectedPermissions = [
            ...selectedPermissions,
            ...values.manage_account,
        ];
    }
    if (values.merchant_onboarding) {
        selectedPermissions = [
            ...selectedPermissions,
            ...values.merchant_onboarding,
        ];
    }
    if (values.edit_merchant_onboarding) {
        selectedPermissions = [
            ...selectedPermissions,
            ...values.edit_merchant_onboarding,
        ];
    }
    if (values.dashboard) {
        selectedPermissions = [...selectedPermissions, ...values.dashboard];
    }
    if (values.payLink) {
        selectedPermissions = [...selectedPermissions, ...values.payLink];
    }
    if (selectedPermissions.length === 0) {
        errors.dashboard = 'Please select at least one permission';
    }
    return errors;
};

export default validate;
